<template>
    <div class="p-2 text-center font-sans text-gray-300 md:p-4">
    
        <BuySellContact />

      <h1 class="text-4xl mt-6">Frequently Asked Questions</h1>
    

         
<h1 class="text-2xl mt-6">How do I pay for accounts/boosting?</h1>

<p class="w-5/6 m-auto md:w-1/2">To minimize transaction times and fees, we are currently only accepting <a href="https://litecoin.org/" class="underline">Litecoin</a>.</p>
<p class="w-5/6 m-auto mt-2 md:w-1/2">Litecoin is a cryptocurrency like Bitcoin but it has much cheaper fees and faster transaction times. You can purchase Litecoin on <a href="https://coinbase.com" class="underline">Coinbase</a>.</p>
<p class="w-5/6 m-auto mt-2 md:w-1/2"><span class="text-red-500">IMPORTANT!</span> don't send us Litecoin straight from Coinbase! Make an address just for <span class="text-red-500">Valorant</span>Accounts using a website <a href="https://walletgenerator.net/?currency=Litecoin" class="underline">like this one</a>.</p>
<p class="w-5/6 m-auto mt-2 md:w-1/2"> Send your money there, set the public address as your payment address in <router-link class="underline" to="/myaccount">your account settings</router-link></p>
<p class="w-5/6 m-auto mt-2 md:w-1/2">Now you're ready to pay for accounts and/or boosting with Litecoin!</p>

<h1 class="text-2xl mt-6">I have an issue/question about the site!</h1>

<p class="w-5/6 m-auto md:w-1/2">We've set up dedicated email channels to serve you as best we can.</p>
<p class="w-5/6 m-auto mt-2 md:w-1/2">For any issues our Buyers are having, we have a prioritized support channel at buyers@<span class="text-red-500">Valorant</span>Accounts.net</p>
<p class="w-5/6 m-auto mt-2 md:w-1/2">For any issues our Sellers are having, we have a prioritized support channel at sellers@<span class="text-red-500">Valorant</span>Accounts.net</p>

<p class="w-5/6 m-auto mt-2 md:w-1/2">For questions, comments and low-priority issues, we'll take them at contact@<span class="text-red-500">Valorant</span>Accounts.net</p>




</div>
</template>

<script>

import BuySellContact from './BuySellContact'

export default {
  name: 'Contact',
  data() {
    return {

    }
  },
  components: {BuySellContact},
 beforeMount(){

 },    

}
</script>


// WEBPACK FOOTER //
// src/components/Contact.vue